import { render, staticRenderFns } from "./DeleteConceptConfirm.vue?vue&type=template&id=3785b73b"
import script from "./DeleteConceptConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteConceptConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports